module.exports = __webpack_public_path__ + "static/Photo01-8baf7e06935848edbd6d82de7a19f12f.png";